import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const WaitingPaymentContainer = styled(Box)(({ theme }) => ({
  background: theme.palette.common.white,
  borderRadius: 10,
  paddingInline: theme.spacing(2),
  paddingBlock: theme.spacing(4),
  boxShadow: theme.shadows[1],
}));
